import { useEffect, useState } from 'react';
import officeInfoService from '../../../services/OfficeInfoService';

export default function useFetchProtegeEmployeeDetail(employeeId) {
  const [protegeEmployeeLoading, setProtegeEmployeeLoading] = useState(false);
  const [protegeEmployeeError, setProtegeEmployeeError] = useState('');
  const [protegeEmployeeDetail, setProtegeEmployeeDetail] = useState({});

  useEffect(() => {
    const fetchProtegeEmployeeDetail = async () => {
      if (!employeeId) return;

      try {
        setProtegeEmployeeLoading(true);
        setProtegeEmployeeError('');

        const userObj = {
          employeeId: employeeId
        };

        if (!employeeId) return;

        const response = await officeInfoService.protegeUserDetails(userObj);

        const userDetails = response?.data?.userDetails;
        const employeeDetail = userDetails?.userDetails || userDetails;

        if (employeeDetail) {
          setProtegeEmployeeDetail(employeeDetail);
        } else {
          setProtegeEmployeeDetail({});
        }
      } catch (error) {
        setProtegeEmployeeDetail({});
        setProtegeEmployeeError(
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            'Error while fetching employee details'
        );
      } finally {
        setProtegeEmployeeLoading(false);
      }
    };
    fetchProtegeEmployeeDetail();
  }, [employeeId]);

  return { protegeEmployeeDetail, protegeEmployeeLoading, protegeEmployeeError };
}
